module.exports = __webpack_public_path__ + "static/media/first.c22355cb.jpg";